<template>
  <div>
    <div
      @click="gotoTripDetail"
      class="box trip-container mt-4 mb-6"
      v-bind:style="{
        backgroundImage: 'url(' + cityImage + ') ',
      }"
    >
      <figcaption class="caption-container fade-bottom">
        <div v-if="!trip.pending">
          <div class="columns is-mobile">
            <div class="column">
              <div
                v-if="trip.tripSummary.status == 'active' && daysUntilStart"
                class="mb-2 is-size-7 "
              >
                {{ daysUntilStart }}
              </div>

              <div
                class="passenger"
                v-for="(passenger, index) in trip.passengers"
                :key="index"
              >
                {{ passenger.firstName }} {{ passenger.lastName }}
              </div>
              <h3 class="is-size-6 has-text-weight-light">
                <span>{{ trip.startDate | formatDate }} </span>
                <span v-if="trip.startDate != trip.endDate"
                  >- {{ trip.endDate | formatDate }}</span
                >
              </h3>

              <h2 class="is-size-4 ">
                {{ tripName }}
              </h2>
            </div>

            <div class="column is-narrow">
              <span class="has-text-right-desktop has-text-left-touch">
                <div class="is-size-6 is-block">Record locator:</div>
                <div class="is-size-4 has-text-weight-bold is-block">
                  {{ trip.recordLocator }}
                </div>
              </span>

              <b-taglist class="mt-4 is-right">
                <b-tag v-for="(type, index) in typeList" :key="index">
                  <SegmentIcon :type="type"></SegmentIcon>
                </b-tag>
              </b-taglist>
            </div>
          </div>
        </div>
        <div v-else>
          <div class="columns">
            <div class="column">
              <h3 class="is-size-6 has-text-grey"></h3>
              <h2 class="is-size-4">Trip Pending</h2>
            </div>
            <div class="column is-narrow">
              <h3 class="is-size-6 has-text-grey">
                Your trip {{ location(trip) }} is currently pending
              </h3>
            </div>
          </div>
          <hr />
          <div>
            <!--<h4 class="is-size-5">Travel Segments</h4>-->
            <div
              class="segment"
              v-for="(segment, index) in trip.segments"
              :key="index"
            >
              <h5 class="is-size-5 is-uppercase has-text-grey-light">
                {{ segment.type }} Segment
              </h5>
              <hr />
            </div>
          </div>
        </div>
      </figcaption>
    </div>
  </div>
</template>

<script>
import SegmentIcon from "../UI/SegmentIcon.vue";
//import CancellationModal from "./CancellationModal.vue";
import router from "@/router";

import { saveAs } from "file-saver";

export default {
  name: "TripCard",
  components: {
    SegmentIcon,
  },
  props: {
    trip: Object,
    isClickable: {
      type: Boolean,
      default: true,
    },
    // showDetails: false,
  },
  data: function() {
    return {
      showDetails: false,
    };
  },
  mounted() {
    //this.getLocationPhoto();
  },
  methods: {
    gotoTripDetail() {
      if (!this.isClickable) {
        console.log("TripCard is not clickable.");
        return false;
      }

      //convert Amadeus recordLocator to hash to avoid showing true record locator in the url
      let hash = this.$helpers.encryptText(this.trip.recordLocator);

      router.push({
        name: "trip-detail",
        params: { recordLocatorHash: hash, tripProp: this.trip },
      });
    },

    location(val) {
      if (val.flight.destinationAirportCode) {
        return " in " + val.flight.destinationAirportCode;
      } else if (val.car.dropoffInfo) {
        return " in " + val.car.dropoffInfo.location.substring(0, 3);
      } else if (val.hotel.hotelName) {
        return " at the " + val.hotel.hotelName;
      } else {
        return "";
      }
    },
    /* 
    launchCancelModal(segment) {
      let config = {
        parent: this,
        component: CancellationModal,
        props: {
          segment: segment,
        },
        trapFocus: false,
        width: 900,
      };
      this.$buefy.modal.open(config);
    },
    toggleDetails() {
      return (this.showDetails = !this.showDetails);
    },
    generateCalendar() {
      // Empty the calendar events
      this.$ics.removeAllEvents()

      // Build the calendar event for the trip
      let language = 'en'
      let subject = this.trip.tripName + ' - Reservation Number: ' + this.trip.recordLocator
      let description = this.calendarDescription
      let location = this.calendarLocation
      let begin = this.trip.startDate
      let stop = this.trip.endDate
      let url = this.calendarUrl
      let organizer = null
      let rrule = null

      // Add to the calendar
      this.$ics.addEvent(language, subject, description, location, begin, stop, url, organizer, rrule)

      // Debug the calendar
      let calendar = this.$ics.calendar()
      // console.log(calendar)

      // Download the calendar
      let fileName = 'TripCircuit-Reservation-' + this.trip.recordLocator
      this.$ics.download(fileName)
    }, 
    generateCalendar() {
      // console.log(this.trip.calendar)
      let filename =
        "TripCircuit-Reservation-" + this.trip.recordLocator + ".ics";
      var blob = new Blob([this.trip.calendar], {
        type: "text/x-vCalendar;charset=utf-8",
      });
      saveAs(blob, filename);
    },
    */
  },
  computed: {
    typeList() {
      return this.trip.tripSummary.typeList;
    },
    tripName() {
      if (this.trip.tripSummary.tripName) {
        return this.trip.tripSummary.tripName;
      } else {
        return this.trip.tripSummary.cityState;
      }
    },
    daysUntilStart() {
      if (this.trip.tripSummary?.daysUntilStart == 0) {
        return "Starts today";
      } else if (this.trip.tripSummary?.daysUntilStart > 0) {
        return "Starts in " + this.trip.tripSummary.daysUntilStart + " days";
      } else if (this.trip.tripSummary?.daysUntilStart < 0) {
        return "Your current trip";
      }
      return null;
    },
    cityImage() {
      if (this.trip.tripSummary.photoUrl) {
        return this.trip.tripSummary.photoUrl;
      } else {
        return "";
      }
    },
    /*
    calendarLocation() {
      return "";
    },
    calendarUrl() {
      return "https://tripcircuit.com/planned-trips";
    },
    calendarDescription() {
      let desc = "";

      if (this.trip.tripDescription) {
        desc += " " + this.trip.tripDescription;
      }

      if (this.trip.recordLocator) {
        desc += "\nGant Travel Reference Number: " + this.trip.recordLocator;
      }

      if (this.trip.passengers) {
        desc += "\nTraveler(s):";

        this.trip.passengers.forEach((passenger) => {
          desc += "\n" + passenger.firstName + " " + passenger.lastName;
        });
      }

      if (this.trip.segments) {
        desc += "\nSegment(s):";

        this.trip.segments.forEach((segment) => {
          desc += "\n" + segment.type;
        });
      }

      if (this.calendarUrl) {
        desc += "\nView full trip details at:\n";
        desc += this.calendarUrl;
        //desc+= '<a href="'+this.calendarUrl+'">'+this.calendarUrl+'</a>'
      }

      return desc;
    },
    */
  },
};
</script>

<style>
.trip-container {
  position: relative;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  padding-bottom: 50%;
  cursor: pointer;
  background-color: #8f9295;
  max-width: 600px;
  margin: 0 auto;
}

@media only screen and (min-width: 1408px) {
  .trip-container {
    padding-bottom: 35%;
  }
}
.segment-heading {
  background: #eee;
}

.caption-container {
  bottom: 0;
  color: #ffffff;
  left: 0;
  margin: 0;
  padding: 2.75rem 0.75rem 0.5rem;
  position: absolute;
  right: 0;
  text-shadow: 0px 1px 2px rgb(17 21 26 / 80%);
}

.caption-container.fade-bottom {
  background-image: linear-gradient(
    180deg,
    rgba(17, 21, 26, 0) 1rem,
    rgba(17, 21, 26, 0.11) 2rem,
    rgba(17, 21, 26, 0.32) 3.1rem,
    rgba(17, 21, 26, 0.5) 4.625rem
  );
  padding-top: 3.3rem;
}
</style>
